import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  Avatar,
  Stack,
  Paper,
  Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StarIcon from "@mui/icons-material/Star";
import { amerjeet, arun, brigdhar, Homeimages, mahesh, nandhini, successcoach, webquote } from "../../../../assets";
import { useNavigate } from "react-router-dom";

const testimonials = [
  {
    name: "Amarjeet Jat",
    role: "Assistant General Manager - Sales & Hospitality at Moonglade by E-infra and IRA venture ",
    image: amerjeet,
    text: [
      "In a world of generic sales tactics, Rajiv Williams is a master of his craft. His 'Luxury Sales Mastery' framework is a game-changer—it shifts the focus from 'chasing the lead' to 'commanding the room' with psychological precision and consultative grace. Since working with Rajiv, I’ve moved away from high-pressure closing and toward high-value leadership. The result? A massive boost in my conversion rates and a newfound level of professional confidence. For any founder or sales leader aiming for the top 1%, Rajiv is the ultimate catalyst for growth. "
    ]
  },
  {
    name: "Mahesh Valsa",
    role: "Driving Growth & Innovation | Key Account Expert in Banking, FinTech, & Digital TransformationDriving Growth & Innovation | Key Account Expert in Banking, FinTech, & Digital Transformation",
    image: mahesh,
    text: [
      "I have known Rajiv for several years and have always been impressed by his deep knowledge and strategic approach to sales and business development. He is a true entrepreneur and advisor, with a keen eye for identifying market opportunities and a talent for building successful sales frameworks. His insights are invaluable, and he consistently demonstrates a forward-thinking perspective. Rajiv is a go-to resource for anyone seeking expert advice and mentorship in the competitive world of sales and consulting."
    ]
  },
  {
    name: "Brigadier (Dr) Inder Sethi",
    role: "Director | Global Strategy Head | Strategy, Innovation & Leadership | 2xTEDx |Keynote Speaker | Author",
    image: brigdhar,
    text: [
      "It's a rare privilege to encounter a professional who not only understands a market but actively defines it. That professional is Rajiv Williams. I've had the pleasure of knowing Rajiv since 2022, and from the outset, his extraordinary clarity of vision and strategic foresight were undeniable.",
      "Rajiv hasn't just entered the uber-luxury sales space; he has masterfully carved a unique and indispensable niche. He possesses an innate ability to connect with clients on a profound level, translating their aspirations into a tangible reality. When you think of trust and integrity in luxury sales, you think of Rajiv. His dedication to his craft and his clients is second to none."
    ]
  },
  {
    name: "Nandini Reddy",
    role: "Partner at Axis Burgundy Private | Wealth Advisory & Relationship Management",
    image: nandhini,
    text: [
      "I had the pleasure of meeting Mr. Rajiv William recently and was instantly struck by his deep understanding of the luxury real estate space in Hyderabad. His network is not only vast but also incredibly well-cultivated — a true reflection of the trust and credibility he’s built over the years.",
      "What stood out to me most is his willingness to support and connect people meaningfully. Despite being a busy professional, he was kind enough to make space for a thoughtful conversation and generously opened a few key doors in his circle for me."
    ]
  },
  {
    name: "Arun K Gattu",
    role: "Vice President - Sales & Marketing Specializing in S&M strategy Expert in market trends & micro-market analysis",
    image: arun,
    text: [
      "I’ve known Rajiv for a long time, and when it comes to real estate, he’s the guy you want in your corner. Need market insights? He’s got them. Looking for the best deals? He knows where to find them. Have a real estate query at midnight? Don’t be surprised if he replies in seconds!",
      "What makes Rajiv stand out is not just his deep industry knowledge but also his cool, no-stress approach. He simplifies things, gives honest advice, and always delivers with speed and clarity. If real estate is on your mind, Rajiv is the one to call!"
    ]
  },

  //   {
  //   name: "Luke Jayakar",
  //   role: "",
  //   image: "/avatar3.jpg",
  //   text: [
  //     "Rajiv Williams, I am truly grateful to have learned under such an experienced real estate coach. The training sessions were very practical and focused on real market situations. Each concept was explained clearly with live examples, which made learning easy. The guidance on customer handling, follow-ups, and closing techniques was extremely helpful. This coaching helped me build confidence in sales conversations and negotiations. The coach always encouraged discipline, consistency, and ethical practices. Doubts were patiently clarified at every stage of training."
  //   ]
  // },
];



const SuccessStoriesSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [previewStart, setPreviewStart] = useState(0);
  const navigate = useNavigate();
  // Top Auto Play
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Sync bottom slider with top slider
  useEffect(() => {
    if (activeIndex < previewStart) {
      setPreviewStart(activeIndex);
    } else if (activeIndex > previewStart + 3) {
      setPreviewStart(activeIndex - 3);
    }
  }, [activeIndex, previewStart]);

  const handlePrev = () => {
    setActiveIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const handlePreviewNext = () => {
    if (previewStart + 4 < testimonials.length) {
      setPreviewStart((prev) => prev + 1);
    }
  };

  const handlePreviewPrev = () => {
    if (previewStart > 0) {
      setPreviewStart((prev) => prev - 1);
    }
  };

  return (
    <Box
      sx={{
        py:{xs:2,md:"auto"},
        // backgroundImage: `
        //   linear-gradient(rgba(15,99,165,0.85), rgba(15,99,165,0.85)),
        //   url(${successcoach})
        // `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: { xs: 'auto', md: "100vh" },
        display: "flex",                 // 🔥 IMPORTANT
    alignItems: "center",           // 🔥 VERTICAL CENTER
    justifyContent: "center",

      }}
    >
      <Container maxWidth="lg" sx={{ width: "100%" }}>

        {/* Header */}
        <Box textAlign="center" mb={6} color="white">
          <Typography variant="h2" fontWeight={700} sx={{ color: 'black' }}>
            Testimonials
          </Typography>
          {/* <Typography sx={{ opacity: 0.8, color: 'black' }}>
            Hear From Our Elite Clients
          </Typography> */}
        </Box>

        {/* Top Slider */}
        <Box sx={{ overflow: "hidden", borderRadius: 4,  }}>
          <Box
            sx={{
              display: "flex",
              width: `${testimonials.length * 100}%`,
              transform: `translateX(-${activeIndex * (100 / testimonials.length)}%)`,
              transition: "transform 0.6s ease",
            }}
          >
            {testimonials.map((item, index) => (
              <Box
                key={index}
                sx={{
                  width: `${100 / testimonials.length}%`,
                  p: 4,
                  color: "white",
                  position: "relative",
                  backdropFilter: "blur(20px)",
                  background: "rgba(14, 105, 209, 0.9)",
                  border: "1px solid rgba(255,255,255,0.25)",
                  borderRadius: 4,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "360px", // keeps cards equal height
                }}
              >
                <Box mb={3} sx={{ textAlign: 'start' }}>
                  <img src={webquote} alt="quote" />
                </Box>

                {item.text.map((paragraph, i) => (
                  <Typography key={i} sx={{ mb: 1, textAlign: 'start', color: "white" }}>
                    {paragraph}
                  </Typography>
                ))}

                {/* <Stack direction="row" spacing={0.5} mb={3}>
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} sx={{ color: "#c57a13" }} />
                  ))}
                </Stack> */}

                <Stack direction="row" spacing={2} alignItems="flex-start"
                  sx={{ mt: "auto" }}>
                  <Avatar src={item.image} />
                  <Box>
                    <Typography variant="h6" fontWeight={600}
                      sx={{
                        color: 'black', textAlign: 'start',
                        fontSize: { xs: '18px', md: "18px" }
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'white', textAlign: 'start' }}>
                      {item.role}
                    </Typography>
                  </Box>
                </Stack>

                {/* Arrows */}
                <Box
                  sx={{
                    position: "absolute",
                    right: 20,
                    bottom: 20,
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <IconButton onClick={handlePrev} sx={{ color: "white" }}>
                    <ArrowBackIosNewIcon fontSize="small" />
                  </IconButton>
                  <IconButton onClick={handleNext} sx={{ color: "white" }}>
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            ))}
          </Box>

          <Box textAlign="center" mt={3}>
            <Button
              variant="contained"
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/in/rajivwilliams/details/recommendations/",
                  "_blank"
                )
              }
              sx={{
                backgroundColor: "#0f63a5",
                borderRadius: "30px",
                px: 4,
                py: 1.5,
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#0c4e82",
                  color: 'white'
                },
                
              }}
            >
              Click to View More
            </Button>
          </Box>
        </Box>

        {/* Bottom Slider */}
        {/* Bottom Center Mode Slider */}
        {/* <Box sx={{ mt: 8, position: "relative", overflow: "hidden" }}>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "transform 0.5s ease",
              transform: `translateX(calc(50% - ${(activeIndex * 320) + 160}px))`,
            }}
          >
            {testimonials.map((item, index) => {
              const isActive = index === activeIndex;

              return (
                <Box
                  key={index}
                  sx={{
                    width: 300,
                    mx: 2,
                    flexShrink: 0,
                    transition: "all 0.4s ease",
                    transform: isActive ? "scale(1)" : "scale(0.85)",
                    opacity: isActive ? 1 : 0.6,
                  }}
                >
                  <Paper
                    onClick={() => setActiveIndex(index)}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      cursor: "pointer",
                      background:
                        isActive
                          ? "rgba(255,255,255,0.25)"
                          : "rgba(255,255,255,0.12)",
                      border: isActive
                        ? "2px solid white"
                        : "1px solid rgba(255,255,255,0.25)",
                      color: "white",
                      height: 160,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar src={item.image} />
                      <Typography fontWeight={600}>
                        {item.name}
                      </Typography>
                    </Stack>

                    <Typography fontSize="14px" sx={{ opacity: 0.9 }}>
                      {item.text[0].substring(0, 90)}...
                    </Typography>
                  </Paper>
                </Box>
              );
            })}
          </Box>

          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 0,
              top: "40%",
              color: "white",
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 0,
              top: "40%",
              color: "white",
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

        </Box> */}


      </Container>
    </Box>
  );
};

export default SuccessStoriesSection;
